var angularModule = angular.module('t2g.common.directives.timePickerDirective', []);

module.exports = angularModule;

angularModule.directive('timepicker', function TimePickerDirective($filter) {
  return {
    restrict: 'E',
    require: '?ngModel',
    replace: true,
    scope: {
      ngModel: '=model',
      start: '@',
      end: '@',
      step: '@',
      dateTime: '=',
    },
    template:
      '<input class="form-control control input-small" type="text" maxlength="5" size="5" ng-model="ngModel">',
    link: function($scope, $element, $attributes, $ngModel) {
      var step = parseInt($scope.step, 10) || 15;
      var start = $scope.start || '06:00';
      var end = $scope.end || '22:00';

      $scope.$watch('ngModel', function(newValue, oldValue) {
        if ((newValue === undefined || newValue === '') && oldValue) {
          $scope.ngModel = oldValue;
        }
      });

      if ($ngModel) {
        // initial: modelValue -> viewValue
        $ngModel.$formatters.push(function(model) {
          var view;
          if (angular.isUndefined(model)) {
            return;
          }

          if ($scope.dateTime) {
            view = moment(model).format('HH:mm');
          } else {
            view = $filter('time')(model, 'mm-to-hh:mm');
          }

          return view;
        });

        // viewValue -> modelValue
        $ngModel.$parsers.push(function(view) {
          var timeParts = view.split(':');
          var timePartsLen = timeParts.length;

          if (timePartsLen === 2 && timeParts[0].length > 0 && timeParts[1].length > 0) {
            var hours = parseInt(timeParts[0], 10);
            var minutes = parseInt(timeParts[1], 10);

            if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
              $ngModel.$setValidity('time', false);
            } else {
              $ngModel.$setValidity('time', true);
            }

            if ($scope.dateTime) {
              var newDateTime = $scope.ngModel;
              newDateTime.setHours(hours);
              newDateTime.setMinutes(minutes);
              return newDateTime;
            } else {
              return hours * 60 + minutes;
            }
          } else {
            $ngModel.$setValidity('time', false);
          }
        });
      }

      $element
        .timepicker({
          timeFormat: 'H:i',
          step: step,
          minTime: start,
          maxTime: end,
          appendTo: $element.parent(),
          forceRoundTime: true,
          disableTouchKeyboard: true,
        })
        .on('click', function() {
          $(this).select();
          $(this).focus();
        });

      /**
       * GC, turn of watchers
       */
      $scope.$on('$destroy', function() {
        $element.off();
      });
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/directives/timePickerDirective.js